<script setup lang="ts">
import { EmbedDatasetSnippet as ModuleEmbedDatasetSnippet } from "@piveau/piveau-hub-ui-modules";
import { useRobotsMetaOverride } from "@/composables/useRobotsMetaOverride";

useRobotsMetaOverride("noindex, nofollow");
</script>

<template>
  <ModuleEmbedDatasetSnippet />
</template>